"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareFormData = exports.ContactField = exports.CustomFieldsStepField = exports.ContactStepField = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _yup = require("yup");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ContactStepField;
exports.ContactStepField = ContactStepField;

(function (ContactStepField) {
  ContactStepField["contacts"] = "contacts";
})(ContactStepField || (exports.ContactStepField = ContactStepField = {}));

var CustomFieldsStepField;
exports.CustomFieldsStepField = CustomFieldsStepField;

(function (CustomFieldsStepField) {
  CustomFieldsStepField["customFields"] = "customFields";
})(CustomFieldsStepField || (exports.CustomFieldsStepField = CustomFieldsStepField = {}));

var ContactField;
exports.ContactField = ContactField;

(function (ContactField) {
  ContactField["id"] = "id";
  ContactField["firstName"] = "firstName";
  ContactField["lastName"] = "lastName";
  ContactField["email"] = "email";
  ContactField["company"] = "company";
  ContactField["country"] = "country";
  ContactField["sendAsEmail"] = "sendAsEmail";
})(ContactField || (exports.ContactField = ContactField = {}));

var ContactFieldLabels;

(function (ContactFieldLabels) {
  ContactFieldLabels["firstName"] = "First name";
  ContactFieldLabels["lastName"] = "Last name";
  ContactFieldLabels["email"] = "Email";
  ContactFieldLabels["company"] = "Company";
  ContactFieldLabels["country"] = "Country";
  ContactFieldLabels["sendAsEmail"] = "Send as";
})(ContactFieldLabels || (ContactFieldLabels = {}));

var errorsDesc = {
  firstName: {
    required: "".concat(ContactFieldLabels.firstName, " is required"),
    max: "".concat(ContactFieldLabels.firstName, " should be less than ${max}")
  },
  lastName: {
    required: "".concat(ContactFieldLabels.lastName, " is required"),
    max: "".concat(ContactFieldLabels.lastName, " should be less than ${max}")
  },
  email: {
    required: "".concat(ContactFieldLabels.email, " is required"),
    email: "This ".concat(ContactFieldLabels.email.toLowerCase(), " is invalid"),
    min: "".concat(ContactFieldLabels.email, " should be at least ${min}"),
    max: "".concat(ContactFieldLabels.email, " should be less than ${max}")
  },
  company: {
    required: "".concat(ContactFieldLabels.company, " is required"),
    min: "".concat(ContactFieldLabels.company, " should be at least ${min}"),
    max: "".concat(ContactFieldLabels.company, " should be less than ${max}")
  },
  country: {
    required: "".concat(ContactFieldLabels.country, " is required"),
    allowed: "The selected ".concat(ContactFieldLabels.country.toLowerCase(), " is invalid")
  },
  sendAsEmail: {
    required: "".concat(ContactFieldLabels.sendAsEmail, " is required"),
    allowed: "The selected ".concat(ContactFieldLabels.sendAsEmail.toLowerCase(), " is invalid")
  }
};
var idSchema = (0, _yup.string)();
var firstNameSchema = (0, _yup.string)().label(ContactFieldLabels.firstName).default('').trim().required(errorsDesc.firstName.required).max(255, errorsDesc.firstName.max);
var lastNameSchema = (0, _yup.string)().label(ContactFieldLabels.lastName).default('').trim().required(errorsDesc.lastName.required).max(255, errorsDesc.lastName.max);
var emailSchema = (0, _yup.string)().label(ContactFieldLabels.email).default('').trim().required(errorsDesc.email.required).min(3, errorsDesc.email.min).max(255, errorsDesc.email.max).email(errorsDesc.email.email);
var companySchema = (0, _yup.string)().label(ContactFieldLabels.company).default('').trim().required(errorsDesc.company.required).min(2, errorsDesc.company.min).max(255, errorsDesc.company.max);
var countrySchema = (0, _yup.string)().label(ContactFieldLabels.country).nullable().default(null).when('$availableCountriesCode', function (availableCountriesCode, schema) {
  return schema.oneOf(availableCountriesCode, errorsDesc.country.allowed);
}).required(errorsDesc.country.required);
var defaultContactsSchema = {
  [ContactField.id]: idSchema,
  [ContactField.firstName]: firstNameSchema,
  [ContactField.lastName]: lastNameSchema,
  [ContactField.email]: emailSchema,
  [ContactField.company]: companySchema,
  [ContactField.country]: countrySchema
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

var prepareFormData = function prepareFormData(fields, email) {
  var schema = {};
  fields.forEach(function (field) {
    schema[field.name] = field.required ? (0, _yup.string)().required("".concat(field.label, " is required")).label(field.label) : (0, _yup.string)().label(field.label);
  });

  var finalSchema = _objectSpread(_objectSpread({}, defaultContactsSchema), {}, {
    [CustomFieldsStepField.customFields]: (0, _yup.string)().label(ContactFieldLabels.sendAsEmail).nullable().default(email).when('$availableUserEmails', function (availableUserEmails, fieldSchema) {
      return fieldSchema.oneOf(availableUserEmails || [], errorsDesc.sendAsEmail.allowed);
    }).required(errorsDesc.sendAsEmail.required),
    [CustomFieldsStepField.customFields]: (0, _yup.object)().nullable().shape(schema)
  });

  return (0, _yup.array)().of((0, _yup.object)().shape(finalSchema)).default([]).required();
};

exports.prepareFormData = prepareFormData;